export const DARK_MODE_PAGES = ['/academy', '/security'];
